import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonAlert, IonIcon, IonItem, IonLabel, IonInput, IonButton } from "@ionic/react";
import axios, { AxiosError, AxiosResponse } from "axios";
import { informationCircle } from "ionicons/icons";
import { useState } from "react";
import { ApiProfileGetInfo } from "../apiproviders/dataprovider";
import { app } from "../configs/appcfg";

const ShowInfo:React.FC = ()=>{
    const [username, setUsername] = useState<string>("");
    const [dateofbirth, setDateofbirth] = useState<string>("");
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [messageTitle, setMessageTitle] = useState<string>('Thông báo');
    async function showInfoHandle(){
        if(dateofbirth.length < 8){
            setIserror(true);
            setMessageTitle("Lỗi");
            setMessage("Ngày sinh không đúng| Định dạng dd/mm/yyyy (vd: 14/07/2000)");
            return;
        }
        let birthparts = dateofbirth.trim().split('/');
        let dd = birthparts[0];
        let mm = birthparts[1];
        let yyyy = birthparts[2];
        if(birthparts.length !==3){
          setIserror(true);
            setMessageTitle("Lỗi");
            setMessage("Ngày sinh không đúng| Định dạng dd/mm/yyyy (vd: 14/07/2000)");
            return;
        }
        try {
            const userSeachInfo = {
                mathisinh: username,
                ngaysinh: dateofbirth,
            };
            let response: AxiosResponse = await ApiProfileGetInfo(userSeachInfo);
            if([200].indexOf(response.status) !== -1){
                let record:any = response.data;
                if([dateofbirth, [Number(dd), Number(mm),yyyy].join('/')].indexOf(record.ngaysinh)!== -1){
                  setIserror(true);
                  setMessageTitle('Thông tin của bạn!');
                  setMessage(`Chào bạn: ${record.hoten} <br/>MK của bạn: ${record.passcode}`)
                }else{
                  setIserror(true);
                  setMessageTitle('Không đúng ngày sinh!');
                  setMessage(`Không hiện mật khẩu khi bạn nhập sai ngày sinh`)
                }
                
            }else{
                setIserror(true);
                setMessageTitle('Lỗi');
                setMessage('Không lấy được thông tin của bạn! Hãy kiểm tra lại Mã số SV và Ngày sinh của bạn');
            }
            
        } catch (error) {
          if(axios.isAxiosError(error))
          {
            setIserror(true);
            setMessageTitle("Lỗi");
            setMessage(error.response?.statusText!);
            //error.message
          }else{
            //console.log(error);
            setIserror(true);
            setMessageTitle("Lỗi");
            setMessage('Lỗi mạng! Lỗi kết nối với server');
          }
        }
    }
    return (
        <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>HỖ TRỢ THÔNG TIN</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="ion-padding ion-text-center">
          <IonGrid>
          <IonRow>
            <IonCol>
              <IonAlert
                  isOpen={iserror}
                  onDidDismiss={() => setIserror(false)}
                  cssClass="my-custom-class"
                  header={messageTitle}
                  message={message}
                  buttons={["ĐÓNG"]}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonIcon
                  style={{ fontSize: "100px", color: "#0040ff" }}
                  icon={informationCircle}
              />
            </IonCol>
          </IonRow>
            <IonRow>
              <IonCol>
              <IonItem>
              <IonLabel position="floating">{app.ui.showinfo.username}</IonLabel>
              <IonInput
                  placeholder={app.ui.showinfo.usernamePlaceHold}
                  type="text"
                  value={username}
                  onIonChange={(e) => setUsername(e.detail.value!)}
                  >
              </IonInput>
              </IonItem>
              </IonCol>
            </IonRow>
      
            <IonRow>
              <IonCol>
              <IonItem>
                <IonLabel position="floating">{app.ui.showinfo.requireinfofield}</IonLabel>
                <IonInput
                  placeholder={app.ui.showinfo.requireinfofieldPlaceHold}
                  type="text"
                  value={dateofbirth}
                  onIonChange={(e) => setDateofbirth(e.detail.value!)}
                  >
                </IonInput>
              </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonButton expand="block" onClick={showInfoHandle}>Hiện MK</IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
          </IonContent>
          </IonPage>
    );
}
export default ShowInfo;